import React, { useEffect} from 'react';
import classes from './CoursesCopy.module.css';
import PropTypes from 'prop-types';
import Course from './Course';
import { isJson } from "../../../utils";
import { onKeyDown } from "../../../service";



const CoursesCopy = ({ filteredlist, setValid, setCourseSelectedId, courseSelectedId }) => {

    const handleClickOnCourse = (id) => {
        if (courseSelectedId !== null) {
            setCourseSelectedId(null)
            setValid(false)
        }
        else {
            setCourseSelectedId(id)
            setValid(true)

        }
    }
    useEffect(() => {
        if (courseSelectedId) 
            setValid(true)
        else 
            setValid(false)
    }, [])

    return (<div className={classes.FilteredCoursesOverflow}>
        <div className={classes.FilteredCourses}>
            {filteredlist && filteredlist.map(course =>
                <div key={course.id}
                    className={`${classes.WrapCourse} ${course.id === courseSelectedId && classes.WrapCourseSelected}`}
                    onClick={() => handleClickOnCourse(course.id)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleClickOnCourse(course.id))}>
                    <Course {...course} isProfession={true} color={isJson(course.additionalData) && JSON.parse(course.additionalData) ? JSON.parse(course.additionalData).color : "#11335B"}></Course>
                </div>)}
        </div>
    </div>)
}

CoursesCopy.propTypes = {
    courses: PropTypes.array
}

export default CoursesCopy;